import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import axios from 'axios';
import {FormattedHTMLMessage} from 'react-intl';

class Congratulations extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hash_id: null,
            provider_phone: null
        };
    }

     componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/details`, config)
            .then(res => {
                const data = res.data;
                const hash_id = data.operation_id === undefined ? data.id : data.operation_id;
                this.setState({ 'hash_id': hash_id });
            }
        );

        axios.get(`${ROOT_URL}/providers/lead`, config)
            .then(response => {
                const provider = response.data;
                this.setState({ 'provider_phone': provider.phone });
            }
        );

        axios.get(`${ROOT_URL}/leads/congratulations`, config);

    }

    render() {
        return (
            <Section className="intro_form">
                <Row>
                    <Col className="text-center" xs={12} md={12} lg={12}>
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    </Col>
                    <Col className="text-center" xs={10} xsOffset={1} md={10} mdOffset={1} lg={10} lgOffset={1}>
                        <FormattedHTMLMessage id="app.step_congratulations_info" description="Congratulations info"/>
                        <FormattedHTMLMessage id="app.step_congratulations_title" description="Congratulations title"/>
                        <FormattedHTMLMessage id="app.step_congratulations_footer" description="Congratulations footer"/>
                        <FormattedHTMLMessage id="app.step_congratulations_salute" description="Congratulations salute"/>
                    </Col>
                </Row>
            </Section>
        );
    }
}

Congratulations.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

Congratulations = TopScrolleable(Congratulations);

Congratulations = withAuthControl(Congratulations);

export default Congratulations;



/** WEBPACK FOOTER **
 ** ./src/components/Congratulations.js
 **/